import React from 'react'
import { Col, Row, Space, Typography } from 'antd'
import ButtonGlobal from '@shared/Button'
import {
  AlertIconIntoDetail,
  AsanIco,
  DeleteIco,
  DownloadIco,
  EditIco,
} from '@modules/CustomIcons'
import i18next from 'i18next'
import './style.scss'
import { useTranslation } from 'react-i18next'
import { IconButtonGroup } from '@shared/IconButtonGroup'
import { OnCloseModalType } from 'pages/Orders/types'
import useDownloadTemplate from '@shared/hooks/useDownloadTemplate'
import {
  OrderType,
  StatusType,
} from 'pages/Orders/SalaryCardOrder/constants/fieldValues.constant'
import { salaryCardListApi, useFetchUpdateOrderStatusMutation } from 'store/reducers/salaryCards/salaryCardList.api'
import { secureLocalStorageGet } from '../../../../../../../helpers'
import { arrayBufferToBase64, AsanSigning } from '@shared/AsanSigning'
import {
  orderDetailsApi,
  useFetchOrderDetailsMutation,
} from 'store/reducers/salaryCards/orderDetails.api'
import DeleteOrderForm from './DeleteOrderForm'
import { IconButtonItemProps } from '@shared/IconButtonGroup/types'
import { useHistory } from 'react-router-dom'
import CustomAccordion from '../accardion/CustomAccordion'
import { saveAs } from 'file-saver'
import * as XLSX from 'xlsx'
import moment from 'moment'
import { useDispatch } from 'react-redux'
import useAsanAdocDownloader from '@shared/AsanSigning/useAsanAdocDownloader'
import { asanSigningAdocFile } from '@app/services/IbSigning/asan'

const exportToExcel = async (data: any) => {
  const headerInfo = {
    fullName: i18next.t('orders.salaryCardOrder.tableTitles.fullName'),
    serialType: i18next.t(
      'orders.salaryCardOrder.tableTitles.identityCardSeries'
    ),
    serialNo: i18next.t(
      'orders.salaryCardOrder.tableTitles.identityCardNumber'
    ),
    pin: i18next.t('orders.salaryCardOrder.tableTitles.pin'),
    position: i18next.t('orders.salaryCardOrder.tableTitles.position'),
    salary: i18next.t('orders.salaryCardOrder.tableTitles.monthlySalary'),
    phone: i18next.t('orders.salaryCardOrder.tableTitles.phoneNumber'),
    // secretKey: i18next.t('orders.salaryCardOrder.tableTitles.codeWord'),
    email: i18next.t('orders.salaryCardOrder.tableTitles.email'),
  }

  const keys = Object.keys(headerInfo)
  const headers = Object.values(headerInfo)

  const formatData = data.map((val: any) => keys.map((k) => val[k]))

  formatData.unshift(headers)
  const worksheet = XLSX.utils.aoa_to_sheet(formatData)
  worksheet['!rows'] = [{ hpt: 30 }]
  worksheet['!cols'] = [
    { wpx: 40 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 },
    { wpx: 150 },
  ]

  const workbook = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array',
  })
  const blob = new Blob([excelBuffer], { type: 'application/octet-stream' })
  const date = new Date()
  saveAs(
    blob,
    `${moment().format('YYYYMMDD')}_salary_card_emp_list_${date.getTime()}.xlsx`
  )
}

const OrderDetailModalFooter: React.FC<OnCloseModalType> = ({
  onCloseModal,
}) => {
  const role = secureLocalStorageGet('rol')
  const history = useHistory()
  const dispatch = useDispatch()

  const [updateOrderStatus, { status: upStatus, isSuccess }] =
    useFetchUpdateOrderStatusMutation()

  const { downloadAdocFile } = useAsanAdocDownloader()

  const [_, { data: detailInformationList, isSuccess: isOdSuccess }] =
    useFetchOrderDetailsMutation({ fixedCacheKey: 'fetchOrderDetails' })
  const disabledCanditation = !(
    detailInformationList?.status === StatusType.PENDING_SIGNER
  )

  const disabledAdocCanditation = !(
    detailInformationList?.status === StatusType.CLOSED
  )

  const disabledSignBtn =
    detailInformationList?.status === StatusType.PENDING_SIGNER

  const { t } = useTranslation()

  const footerActionBtns: IconButtonItemProps[] = [
    {
      icon: <DownloadIco />,
      title: t('orders.salaryCardOrder.buttonsLabels.downloadFileTemplate'),
      key: 'adoc',
      visible: false,
      disabled: false,
      onClick: () => exportToExcel(detailInformationList?.employees),
    },
    {
      icon: <EditIco />,
      title: i18next.t('transfers.edit2'),
      key: 'edit',
      visible: false,
      disabled: disabledCanditation,
      onClick: () => {
        history.push(
          `/orders/salary-card/update/${detailInformationList?.orderNo}`
        )
      },
    },
    {
      icon: <DeleteIco />,
      modal: {
        footer: null,
        title: t('orders.salaryCardOrder.constants.deleteReason'),
        width: 600,
        bodyStyle: { maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' },
        modalContent: (
          <DeleteOrderForm orderNo={detailInformationList?.orderNo} />
        ),
      },
      title: i18next.t('transfers.delete'),
      key: 'delete',
      visible: false,
      disabled: disabledCanditation,
      onClick: () => {},
    },
  ]

  const footerBtnsTransferFooter = [
    {
      icon: <AsanIco />,
      title: i18next.t('transfers.downloadAdoc'),
      key: 'adoc',
      visible: false,
      disabled: disabledAdocCanditation,
      onClick: () => {
        downloadAdocFile(
          asanSigningAdocFile,
          detailInformationList?.transactionId,
          `${detailInformationList?.orderNo}.adoc`
        )
      },
    },
  ]

  const onSigning = async () => {
    try {
      if (isOdSuccess) {
        return {
          files: [
            {
              name: `${detailInformationList?.orderNo}.json`,
              mimeType: 'application/json',
              encodedBytes: arrayBufferToBase64(detailInformationList),
            },
          ],
        }
      }
    } catch (error) {
      console.log('🚀 ~ onSigning ~ error:', error)
    }
  }

  return (
    <>
      <Row>
        <CustomAccordion />
      </Row>
      <Row
        justify={'space-between'}
        align={'middle'}
        style={{ marginTop: '20px' }}
      >
        <Col span={8}>
          <Row style={{ width: '100%' }} gutter={20}>
            <Col>
              <IconButtonGroup buttons={footerActionBtns} />
            </Col>
            <Col>
              <IconButtonGroup buttons={footerBtnsTransferFooter} />
            </Col>
            {detailInformationList?.orderType === OrderType.URGENT && (
              <Row
                style={{
                  width: '350px',
                  padding: '12px',
                  borderRadius: '8px',
                  backgroundColor: '#F3F6FA',
                  fontSize: '10px',
                  fontWeight: 500,
                  display: 'flex',
                }}
              >
                <div style={{ marginRight: '8px' }}>
                  <AlertIconIntoDetail />
                </div>

                <Typography.Text>
                  {t('orders.salaryCardOrder.constants.commissionFee')}
                </Typography.Text>
              </Row>
            )}
          </Row>
        </Col>

        <Col>
          <Space>
            <ButtonGlobal
              size="large"
              color="#015CD1"
              customType="default"
              onClick={onCloseModal}
            >
              {t('common.close')}
            </ButtonGlobal>
            {role === 2 &&
              detailInformationList?.status === StatusType.PENDING_SIGNER && (
                <AsanSigning
                  docType="SCO"
                  asanKey="asanSignInDetail"
                  handleSigning={onSigning}
                  checkSignCallback={() => disabledSignBtn}
                  status={upStatus}
                  afterCloseFn={() => {
                    if (isSuccess) {
                      dispatch(
                        orderDetailsApi.endpoints.fetchOrderDetails.initiate(
                          { orderNo: detailInformationList?.orderNo },
                          { fixedCacheKey: 'fetchOrderDetails' }
                        )
                      )
                      dispatch(salaryCardListApi.util.invalidateTags(['SalaryCardStatusList', 'SalaryCardList']))
                    }
                  }}
                  onComplete={(data) => {
                    updateOrderStatus({
                      orderNo: detailInformationList?.orderNo,
                      ...data,
                    })
                  }}
                />
              )}
          </Space>
        </Col>
      </Row>
    </>
  )
}

export default OrderDetailModalFooter
